export default __webpack_public_path__ + "static/media/Scope for Improvement.aee084dd.svg";